<template>
  <div>
    <!-- breadcrumb start -->
    <div class="breadcrumb-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="page-title">
              <h2>Zerofast智能家居专家</h2>
            </div>
          </div>
          <div class="col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="//www.ai-ifast.com/index.html">Home</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">智能网关</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <!-- section start -->
    <section class="section-b-space">
      <div class="collection-wrapper">
        <div class="container">
          <div class="row data-sticky_parent">
            <div class="col-lg-12 col-sm-12 col-xs-12">
              <div class="container-fluid p-0">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-12 product_img_scroll image-scroll" data-sticky_column>
                        <div style="display: flex; justify-content: center;">
                          <img src="https://www.zerofast.net/assets/images/product/nx3/smart_tp.png" style="max-width: 70%; max-height: 600px; object-fit: contain;" alt="" class="img-fluid blur-up lazyload">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 rtl-text">
                    <div class="product-right pro_sticky_info" data-sticky_column>
                      <h2>Zerofast智能网关服务</h2>
                      <div class="rating-section">
                        <div class="rating">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                        </div>
                        <h6 style="color: red">月销 {{ sales.monthly }}</h6>
                      </div>
                      <div class="label-section">
                        <span class="badge badge-theme-color" v-for="tag in goods.plan.tags" :key="tag" style="margin: 0px 5px;">{{ tag }}</span>
                        <span class="label-text" v-if="goods.service.tag"><i class="fa fa-ticket"/> 服务{{ goods.service.tag }}</span>
                      </div>
                      <h3 class="price-detail">
                        ￥{{ (goods.plan.price + goods.service.price) | number('0,0.00') }}元<del v-if="(goods.plan.discount + goods.service.discount) !== (goods.plan.price + goods.service.price)">￥{{ goods.plan.discount + goods.service.discount | number('0,0.00') }}</del>
                      </h3>
<!--                      <ul class="color-variant">-->
<!--                        <li class="bg-light0 active"></li>-->
<!--                        <li class="bg-light1"></li>-->
<!--                        <li class="bg-light2"></li>-->
<!--                      </ul>-->
                      <div id="selectSize" class="addeffect-section product-description border-product">
<!--                        <div class="modal fade" id="sizemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">-->
<!--                          <div class="modal-dialog modal-dialog-centered" role="document">-->
<!--                            <div class="modal-content">-->
<!--                              <div class="modal-header">-->
<!--                                <h5 class="modal-title" id="exampleModalLabel">Sheer Straight Kurta</h5>-->
<!--                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">-->
<!--                                  <span aria-hidden="true">&times;</span>-->
<!--                                </button>-->
<!--                              </div>-->
<!--                              <div class="modal-body">-->
<!--                                <img src="../assets/images/size-chart.jpg" alt="" class="img-fluid blur-up lazyload">-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <h6 class="error-message">please select size</h6>-->
                        <div class="size-box">
                          <ul>
                            <li v-for="plan in plans" :key="plan.plan_id" :class="{active: plan.plan_id === goods.plan.plan_id}">
                              <a @click="handlePlan(plan)" :class="{'plan-active': plan.plan_id === goods.plan.plan_id, 'plan': plan.plan_id !== goods.plan.plan_id }" v-html="plan.name"></a>
                            </li>
                          </ul>
                        </div>
                        <div class="size-box">
                          <ul>
                            <li v-for="service in services" :key="service.service_id" :class="{active: service.service_id === goods.service.service_id}">
                              <a @click="handleService(service)" :class="{'plan-active': service.service_id === goods.service.service_id, 'plan': service.service_id !== goods.service.service_id }" v-if="!(service.service_id === 'trial' && goods.plan.tag === 'media')">
                                {{ service.name }}
                                <span v-if="service.price > 0">
                                  <span style="font-size: 10px; margin-top: 5px; margin-left: 5px;">{{ (service.price) | number('+0,0.00')}}</span>
                                </span>
                              </a>
                            </li>
                          </ul>
                          <ul>
                            <li v-for="service in services" :key="service.service_id" :class="{active: service.service_id === goods.service.service_id}" v-if="goods.plan.tag === service.tag">
                              <a @click="handleService(service)" :class="{'plan-active': service.service_id === goods.service.service_id, 'plan': service.service_id !== goods.service.service_id }">
                                {{ service.name }}
                                <span v-if="service.price > 0">
                                  <span style="font-size: 10px; margin-top: 5px; margin-left: 5px;">{{ (service.price) | number('+0,0.00')}}</span>
                                </span>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <h6 class="product-title">数量</h6>
                        <div class="qty-box">
                          <div class="input-group">
                            <span class="input-group-prepend" @click="handleQty(-1)">
                              <button type="button" class="btn quantity-left-minus" data-type="minus" data-field="">
                                <i class="ti-angle-left"></i>
                              </button>
                            </span>
                            <input type="text" name="quantity" class="form-control input-number" :value="goods.qty">
                            <span class="input-group-prepend" @click="handleQty(1)">
                              <button type="button" class="btn quantity-right-plus" data-type="plus" data-field="">
                                <i class="ti-angle-right"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="product-buttons">
                        <a @click="quickBuy" class="btn btn-solid hover-solid btn-animation">
                          <i class="fa fa-credit-card-alt fz-16 me-2" aria-hidden="true"></i>立即购买
                        </a>
                        <a @click="addCart" class="btn btn-solid">
                          <i class="fa fa-shopping-cart me-1" aria-hidden="true"></i> 加入购物车
                        </a>
                      </div>
<!--                      <div class="product-count">-->
<!--                        <ul>-->
<!--                          <li>-->
<!--                            <img src="../assets/images/icon/truck.png" class="img-fluid" alt="image">-->
<!--                            <span class="lang">全国包邮；支付满1500元全球包邮费</span>-->
<!--                          </li>-->
<!--                        </ul>-->
<!--                      </div>-->
                      <div class="border-product">
                        <h6 class="product-title"></h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Section ends -->
    <!-- product-tab starts -->
    <section class="tab-product pt-0 m-0">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-12">
            <ul class="nav nav-tabs nav-material" id="top-tab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="top-home-tab" data-bs-toggle="tab" href="#top-home" role="tab" aria-selected="true">
                  <i class="icofont icofont-ui-home"></i>产品介绍 </a>
                <div class="material-border"></div>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="profile-service-tab" data-bs-toggle="tab" href="#top-service" role="tab" aria-selected="false">
                  <i class="icofont icofont-man-in-glasses"></i>售后服务 </a>
                <div class="material-border"></div>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="profile-top-tab" data-bs-toggle="tab" href="#top-profile" role="tab" aria-selected="false">
                  <i class="icofont icofont-man-in-glasses"></i>设备参数 </a>
                <div class="material-border"></div>
              </li>
            </ul>
            <div class="tab-content nav-material" id="top-tabContent">
              <div class="tab-pane fade show active" id="top-home" role="tabpanel" aria-labelledby="top-home-tab">
                <div class="product-tab-discription" style="display: flex; justify-content: center;">
                  <div class="part" style="width: 600px;">
                    <h3>套餐规则：</h3>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      1. 780套餐内容包括智联盒子➕tplink ax3000路由器一个，使用时间为一个月。
                    </li>
                    <br/>
                    <br/>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      2. 使用到期后，会自动停止加速服务功能，您可以登入官网自由选择套餐充值继续使用，有三种套餐选择如下：80元/月、400元/6个月、2400元/永久(需联系客服确认条件)
                    </li>
                    <br/>
                    <br/>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      3. 套餐内包邮国内中转仓，如需包邮海外需要额外支付运费300元。
                    </li>
                    <br/>
                    <br/>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      <b>注意：以上是该套餐的大致规则内容，具体细节和操作方式可与客服详询。</b>
                    </li>
                    <br/>
                    <br/>

                    <img src="https://www.zerofast.net/assets/images/product/nx3/10.jpg" alt="" class="img-fluid blur-up lazyload" style="width: 100%; border: 0px; display: block;">
                    <img src="https://www.zerofast.net/assets/images/poster/1-1.jpeg" alt="" class="img-fluid blur-up lazyload" style="width: 100%; border: 0px; display: block;">
                    <img src="https://www.zerofast.net/assets/images/poster/1-2.jpeg" alt="" class="img-fluid blur-up lazyload" style="width: 100%; border: 0px; display: block;">
                    <img src="https://www.zerofast.net/assets/images/poster/1-3.jpeg" alt="" class="img-fluid blur-up lazyload" style="width: 100%; border: 0px; display: block;">
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="top-service" role="tabpanel" aria-labelledby="profile-top-tab">
                <ul>
                  <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">1. 感谢您选择我们的商品。为了确保您的购物体验，我们提供收货后7天的无理由退换货保障服务。</li>
                  <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">2. 如果您在收到商品后的7个工作日内对所购商品不满意，您可以无需提供任何理由申请退换货。</li>
                  <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">3. 退换货商品必须保持原始状态，未经使用，并且包装、标签完好无损，以确保商品的二次销售。</li>
                  <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">4. 退换货的物流费用将由买家承担，具体费用请咨询我们的客服人员，我们会提供准确的退换货流程指引。</li>
                  <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">5. 您退回的商品经核对完好无损后，我们将在7个工作日内为您办理退款或换货，退款将原路返回到您的支付账户。</li>
                  <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">6. 我们承诺为您提供优质的客户服务，如果您遇到任何问题，请随时与我们的客服团队联系，我们将竭诚为您解决。感谢您对我们的支持与理解！</li>
                </ul>
              </div>
              <div class="tab-pane fade" id="top-profile" role="tabpanel" aria-labelledby="profile-top-tab">
                <div class="single-product-tables">
                  <table>
                    <tbody>
                    <tr>
                      <td>型号:</td>
                      <td>Linux</td>
                    </tr>
                    <tr>
                      <td>CPU:</td>
                      <td>四核 Arm Cortex-A55</td>
                    </tr>
                    </tbody>
                  </table>
                  <table>
                    <tbody>
                    <tr>
                      <td>网卡:</td>
                      <td>1000Mbps</td>
                    </tr>
                    <tr>
                      <td>内存:</td>
                      <td>2G</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- product-tab ends -->
    <!-- product section start -->
    <section class="section-b-space ratio_asos">
      <div class="container">
        <div class="row">
          <div class="col-12 product-related">
            <h2></h2>
          </div>
        </div>
      </div>
    </section>
    <!-- product section end -->
    <!-- recently purchase product -->
<!--    <div class="media recently-purchase">-->
<!--      <img src="../assets/images/pro3/sm.jpg" alt="Floral Dress ">-->
<!--      <div class="media-body">-->
<!--        <div>-->
<!--          <div class="title"> Some recently purchase this item </div>-->
<!--          <a href="#">-->
<!--            <span class="product-name"> Floral Dress </span>-->
<!--          </a>-->
<!--          <small class="timeAgo">50 minutes ago</small>-->
<!--        </div>-->
<!--      </div>-->
<!--      <a href="javascript:void(0)" class="close-popup fa fa-times"></a>-->
<!--    </div>-->
    <!-- recently purchase product -->
    <!-- Add to cart modal popup start-->
<!--    <div class="modal fade bd-example-modal-lg theme-modal cart-modal" id="addtocart" tabindex="-1" role="dialog" aria-hidden="true">-->
<!--      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">-->
<!--        <div class="modal-content">-->
<!--          <div class="modal-body modal1">-->
<!--            <div class="container-fluid p-0">-->
<!--              <div class="row">-->
<!--                <div class="col-12">-->
<!--                  <div class="modal-bg addtocart">-->
<!--                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">-->
<!--                      <span aria-hidden="true">&times;</span>-->
<!--                    </button>-->
<!--                    <div class="media">-->
<!--                      <a href="#">-->
<!--                        <img class="img-fluid blur-up lazyload pro-img" src="../assets/images/fashion/product/43.jpg" alt="">-->
<!--                      </a>-->
<!--                      <div class="media-body align-self-center text-center">-->
<!--                        <a href="#">-->
<!--                          <h6>-->
<!--                            <i class="fa fa-check"></i>Item <span>men full sleeves</span>-->
<!--                            <span> successfully added to your Cart</span>-->
<!--                          </h6>-->
<!--                        </a>-->
<!--                        <div class="buttons">-->
<!--                          <a href="#" class="view-cart btn btn-solid">Your cart</a>-->
<!--                          <a href="#" class="checkout btn btn-solid">Check out</a>-->
<!--                          <a href="#" class="continue btn btn-solid">Continue shopping</a>-->
<!--                        </div>-->
<!--                        <div class="upsell_payment">-->
<!--                          <img src="../assets/images/payment_cart.png" class="img-fluid blur-up lazyload" alt="">-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="product-section">-->
<!--                      <div class="col-12 product-upsell text-center">-->
<!--                        <h4>Customers who bought this item also.</h4>-->
<!--                      </div>-->
<!--                      <div class="row" id="upsell_product">-->
<!--                        <div class="product-box col-sm-3 col-6">-->
<!--                          <div class="img-wrapper">-->
<!--                            <div class="front">-->
<!--                              <a href="#">-->
<!--                                <img src="../assets/images/fashion/product/1.jpg" class="img-fluid blur-up lazyload mb-1" alt="cotton top">-->
<!--                              </a>-->
<!--                            </div>-->
<!--                            <div class="product-detail">-->
<!--                              <h6>-->
<!--                                <a href="#">-->
<!--                                  <span>cotton top</span>-->
<!--                                </a>-->
<!--                              </h6>-->
<!--                              <h4>-->
<!--                                <span>$25</span>-->
<!--                              </h4>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div class="product-box col-sm-3 col-6">-->
<!--                          <div class="img-wrapper">-->
<!--                            <div class="front">-->
<!--                              <a href="#">-->
<!--                                <img src="../assets/images/fashion/product/34.jpg" class="img-fluid blur-up lazyload mb-1" alt="cotton top">-->
<!--                              </a>-->
<!--                            </div>-->
<!--                            <div class="product-detail">-->
<!--                              <h6>-->
<!--                                <a href="#">-->
<!--                                  <span>cotton top</span>-->
<!--                                </a>-->
<!--                              </h6>-->
<!--                              <h4>-->
<!--                                <span>$25</span>-->
<!--                              </h4>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div class="product-box col-sm-3 col-6">-->
<!--                          <div class="img-wrapper">-->
<!--                            <div class="front">-->
<!--                              <a href="#">-->
<!--                                <img src="../assets/images/fashion/product/13.jpg" class="img-fluid blur-up lazyload mb-1" alt="cotton top">-->
<!--                              </a>-->
<!--                            </div>-->
<!--                            <div class="product-detail">-->
<!--                              <h6>-->
<!--                                <a href="#">-->
<!--                                  <span>cotton top</span>-->
<!--                                </a>-->
<!--                              </h6>-->
<!--                              <h4>-->
<!--                                <span>$25</span>-->
<!--                              </h4>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div class="product-box col-sm-3 col-6">-->
<!--                          <div class="img-wrapper">-->
<!--                            <div class="front">-->
<!--                              <a href="#">-->
<!--                                <img src="../assets/images/fashion/product/19.jpg" class="img-fluid blur-up lazyload mb-1" alt="cotton top">-->
<!--                              </a>-->
<!--                            </div>-->
<!--                            <div class="product-detail">-->
<!--                              <h6>-->
<!--                                <a href="#">-->
<!--                                  <span>cotton top</span>-->
<!--                                </a>-->
<!--                              </h6>-->
<!--                              <h4>-->
<!--                                <span>$25</span>-->
<!--                              </h4>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- Add to cart modal popup end-->
    <!-- tap to top start -->
    <div class="tap-top">
      <div @click="showCustomer">
<!--        <i class="fa fa-angle-double-up"></i>-->
        <i class="fa fa-wechat"></i>
      </div>
    </div>
    <!-- tap to top end -->
    <!-- added to cart notification -->
    <div :class="{'added-notification': true, 'show': showAddCart}">
      <img :src="goods.pic" class="img-fluid" alt="">
      <h3>加入购物车</h3>
    </div>
    <!-- added to cart notification -->
    <a-modal title="客服微信" v-model="showCustomerWechat" :footer="null">
      <div style="display: flex; justify-content: center;">
        <img src="https://www.zerofast.net/assets/images/wechat.png" style="width: 240px;" alt="客服微信">
      </div>
    </a-modal>
    <a-modal title="登录" v-model="showWechat" :footer="null" style="display: flex; justify-content: center;">
      <LoginSection :wechat="wechat"></LoginSection>
    </a-modal>
  </div>
</template>

<script>
import { setCart, getCart, getToken } from '@/libs/util'
import { getPlans, getSales } from '@/api/product'
import { baseMixin } from '@/libs/app-mixin'
import config from '@/config'
import LoginSection from '@/components/blocks/LoginSection'

export default {
  name: 'Layout',
  mixins: [baseMixin],
  components: {
    LoginSection
  },
  data () {
    return {
      showAddCart: false,
      showCustomerWechat: false,
      showWechat: false,
      plans: [],
      services: [],
      wechat: {
        url: ''
      },
      goods: {
        pic: 'https://www.zerofast.net/assets/images/product/smart.png',
        plan: {
          plan_id: '',
          name: '',
          price: 0,
          discount: 0,
          tags: []
        },
        service: {
          service_id: '',
          name: '',
          price: 0,
          discount: 0,
          tags: []
        },
        qty: 1
      },
      cart: [],
      sales: {
        monthly: 0
      }
    }
  },
  methods: {
    handlePlan (plan) {
      this.goods.plan = plan
      this.goods.service = {
        service_id: '',
        name: '',
        price: 0,
        discount: 0,
        tags: []
      }
      if (this.goods.service.service_id === 'trial') {
        this.goods.service = {
          service_id: '',
            name: '',
            price: 0,
            discount: 0,
            tags: []
        }
      }
    },
    handleService (service) {
      this.goods.service = service
    },
    handleQty (i) {
      this.goods.qty += i
      if (this.goods.qty === 0) {
        this.goods.qty = 1
      }
    },
    showCustomer () {
      this.showCustomerWechat = true
    },
    scrollWechat () {
      window.scrollTo(0, document.body.scrollHeight)
    },
    getPlans () {
      getPlans('').then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.plans = res.result.plans || []
        this.services = [
          {
            service_id: '',
            name: '请选择',
            price: 0,
            discount: 0,
            sign: '',
            tag: '',
            time: ''
          },
          ...
          res.result.services
        ]
        if (this.plans.length === 0) {
          setTimeout(() => {
            this.getPlans()
          }, 1000)
          return false
        }
        this.goods.plan = this.plans[0]
        this.goods.service = this.services[0]
      })
    },
    addCart () {
      if (this.goods.service.service_id === '') {
        this.$message.info('请选择套餐')
        return false
      }
      this.showAddCart = true
      setTimeout(() => {
        this.showAddCart = false
      }, 5000)

      let flag = true
      this.cart.forEach(v => {
        if (v.id === this.goods.plan.plan_id + '-' + this.goods.service.service_id) {
          flag = false
          v.qty += this.goods.qty
        }
      })
      if (flag === true) {
        this.cart.push({
          id: this.goods.plan.plan_id + '-' + this.goods.service.service_id,
          plan: {
            tag: this.goods.plan.tag,
            plan_id: this.goods.plan.plan_id,
            name: this.goods.plan.name.replaceAll('<br/>', ''),
            price: this.goods.plan.price,
            discount: this.goods.plan.discount,
            sign: this.goods.plan.sign
          },
          service: this.goods.service,
          pic: this.goods.pic,
          qty: this.goods.qty
        })
      }
    },
    getWechatUrl () {
      const token = getToken()
      if (token === false) {
        const redirect = encodeURI(config.ssoUrl)
        if (this.checkEnv() === 'web') {
          const appid = 'wx56610615281b2c87'
          const state = 'member'
          this.wechat.url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_login&state=${state}#wechat_redirect`
        } else if (this.checkEnv() === 'wechat') {
          const appid = 'wx3cf92c62c10802be'
          const state = 'h5'
          this.wechat.url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
        }
        return false
      }
    },
    checkAuth () {
      this.token = getToken()
      if (this.token === false) {
        if (this.checkEnv() === 'wechat') {
          location.href = this.wechat.url
        } else {
          this.showWechat = true
        }
        return false
      }
      return true
    },
    quickBuy () {
      if (this.goods.service.service_id === '') {
        this.$message.info('请选择套餐')
        return false
      }
      if (!this.checkAuth()) {
        return false
      }
      this.cart = []
      this.addCart()
      setTimeout(() => {
        location.href = '/#/checkout'
      }, 100)
    },
    getSales () {
      getSales().then(res => {
        if (res.code !== 200) {
          // this.$message.info(res.msg)
          setTimeout(() => {
            this.getSales()
          }, 1000)
          return false
        }
        this.sales = res.result
      })
    }
  },
  mounted () {
    this.getPlans()
    this.cart = getCart()
    this.getSales()
    this.getWechatUrl()
  },
  watch: {
    cart: {
      handler (newValue, oldValue) {
        this.$parent.cart = this.cart
        if (this.cart.length > 0) {
          setCart(this.cart)
        }
      }
    }
  }
}
</script>

<style scoped>
  .plan-active {
    color: #fff;
  }
  .plan {
    color: #222;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue